import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center px-4"
      >
        <h1 className="text-9xl font-bold text-[#4B83F2] mb-4">404</h1>
        <h2 className="text-3xl font-bold text-gray-900 mb-4">Page Not Found</h2>
        <p className="text-xl text-gray-600 mb-8 max-w-md mx-auto">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex gap-4 justify-center">
          <button 
            onClick={() => navigate('/')}
            className="bg-[#4B83F2] text-white px-8 py-3 rounded-lg font-semibold hover:bg-[#3A6CD4] transition-colors"
          >
            Go to Homepage
          </button>
          <button 
            onClick={() => navigate(-1)}
            className="bg-white text-[#4B83F2] px-8 py-3 rounded-lg font-semibold border-2 border-[#4B83F2] hover:bg-[#EBF3FF] transition-colors"
          >
            Go Back
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default NotFound; 